import { SessionIdForToken } from 'src/models/authentication';

import { Callback } from 'src/util/query/models/Callback';

export const createGetTheSessionIdFromTheAccessTokenCallback = (
	setSessionId: (sessionId: string) => void
): Callback<SessionIdForToken> => {
	class GetTheSessionIdFromTheAccessTokenCallback extends Callback<SessionIdForToken> {
		public constructor(private readonly setSessionId: (sessionId: string) => void) {
			super();
		}

		failureCallbackFunction = (failureResponse: unknown): void => {
			this.logFailureResponse(failureResponse);
		};

		successCallbackFunction = (successResponse: SessionIdForToken): void => {
			this.setSessionId(successResponse.sessionId);
		};
	}

	return new GetTheSessionIdFromTheAccessTokenCallback(setSessionId);
};
